<div class="tc-container">
  <mat-grid-list [cols]="3">
    <mat-grid-tile [colspan]="1" [rowspan]="1"></mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="1"
      ><mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="1"></mat-grid-tile>
  </mat-grid-list>
</div>
